exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group input[data-v-1b67d607]{width:100%;text-align:left!important}.form-group input[data-v-1b67d607]::-moz-placeholder{color:#d3d3d3}.form-group input[data-v-1b67d607]:-ms-input-placeholder{color:#d3d3d3}.form-group input[data-v-1b67d607]::placeholder{color:#d3d3d3}", ""]);

// exports
